import config from '@/config'
export const getWebBankingUrl = (email?: string) => {
  if (!email) {
    throw new Error('No user found for web banking')
  }
  return `${config.OLKY_BANKING_URL}/connect?email=${encodeURIComponent(email)}`
}
